import { type ApiResponse } from "apisauce"

export function handleTemplateImportError(
  response: ApiResponse<any, any>,
  fileName: string
) {
  const contentType = response.headers?.["content-type"] || ""

  if (
    [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/octet-stream",
      "application/vnd.openxmlformats",
      "text/csv"
    ]?.includes(contentType)
  ) {
    const blob = new Blob([response.data], { type: contentType })

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    return true
  }

  return false
}
